import { useAppContainerContext } from '../AppContainerContext';
import { useSiesta } from '../SiestaProvider';
import { openConversationFromServer } from './openConversationFromServer';

export function useOpenConversation() {
  const { loadHistory, beginHistoryLoad, endHistoryLoad, resumeActiveTurn, appendFailedMarker } =
    useSiesta();
  const { conversationId, setConversationId, setSiestaMode } = useAppContainerContext();

  return (id: string) =>
    openConversationFromServer(id, {
      currentConversationId: conversationId,
      loadHistory,
      beginHistoryLoad,
      endHistoryLoad,
      resumeActiveTurn,
      appendFailedMarker,
      setConversationId,
      setSiestaMode,
    });
}
